<template>
  <div>
    <div>
      <el-slider v-model="scale" :max="300" />
      {{ scale }}
    </div>
    <div>
      <el-color-picker
        v-model        ="borderColor"
        :predefine     ="predefineColors"
        @active-change ="activeChangeHandler"
        show-alpha
      />
    </div>

    <el-checkbox-group v-model="typeFilter">
      <el-checkbox-button v-for="type in types" :label="type" :key="type">{{type}}</el-checkbox-button>
    </el-checkbox-group>
    <el-input v-model="filterKey"/>

    <div class="icon-container">
      <div
        v-for      ="icon in filteredArray"
        :key       ="icon.id"
        draggable  ="true"
        @dragstart ="drag(icon, $event)"
        class      ="icon">
        <img draggable="false" :title="icon.name" :src="icon.image">
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'IconPicker',
  data () {
    return {
      filterKey       : '',
      types           : ['champion', 'item'],
      typeFilter      : ['champion', 'item'],
      typeList        : [],
      scale           : 100,
      borderColor     : 'rgba(218,179,0,1)',
      predefineColors : [
        'rgba(218,179,0,1)',
        'rgba(255,0,0,1)',
        'rgba(0,255,0,1)',
        'rgba(0,0,255,1)'
      ]
    }
  },
  methods: {
    activeChangeHandler (color) {
      this.borderColor = color
    },
    drag (icon, e) {
      this.$emit('picked', {
        id          : this.getUniqueString(),
        type        : 'icon',
        width       : 100,
        height      : 100,
        borderColor : this.borderColor,
        iconId      : icon.id,
        scale       : this.scale,
        range       : 1,
        label       : ''
      })
    }
  },
  computed: {
    filteredArray () {
      return this.icons.filter(icon => {
        if (this.typeFilter.indexOf(icon.type) === -1) return false
        return icon.name.toLowerCase().indexOf(this.filterKey) === 0
      })
    },
    ...mapGetters('object/icon', [
      'icons'
    ])
  }
}
</script>

<style scoped>
.icon {
  position         : relative;
  margin           : 5px;
  width            : 60px;
  height           : 60px;
  background-color : blue;
  display          : inline-block;
}
.icon-container {
  overflow-y : scroll;
  height     : 300px;
}
img {
  width  : 100%;
  height : auto;
}
::-webkit-scrollbar {
  width : 10px;
}
::-webkit-scrollbar-thumb {
  background    : #23466e;
  border-radius : 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/object/controller/icon-picker.vue